import React, { useState } from 'react';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { useCarrierCustomers } from '../../hooks/useCarrierCustomers';
import { useCarrierPickups } from '../../hooks/useCarrierPickups';
import { carrierApi } from '../../firebase/functionsService';
import CustomerForm from './CustomerForm';
import PickupForm from './PickupForm';
import { ui } from './carrierStyles';

export default function CarrierCustomers() {
  const { orgId, isStaff, loading: orgLoading } = useCarrierOrg();
  const { customers, loading: customersLoading } = useCarrierCustomers(orgId);
  const { pickups, loading: pickupsLoading } = useCarrierPickups(orgId);
  // editing: { kind: 'customer' | 'pickup', item: objekt | null (ny) }
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState('');

  if (orgLoading) return <p style={ui.hint}>Laster…</p>;
  if (!isStaff) return <p style={ui.hint}>Bare administratorer og dispatchere ser denne siden.</p>;

  async function remove(kind, item) {
    if (!window.confirm(`Slette ${item.name}?`)) return;
    setError('');
    try {
      if (kind === 'customer') await carrierApi.deleteCarrierCustomer({ orgId, customerId: item.id });
      else await carrierApi.deleteCarrierPickup({ orgId, pickupId: item.id });
    } catch (err) {
      setError(err.message || 'Kunne ikke slette');
    }
  }

  const done = () => setEditing(null);

  return (
    <>
      <h1 style={ui.h1}>Kunder og hentesteder</h1>
      {error && <p role="alert" style={ui.error}>{error}</p>}

      <div style={ui.card}>
        <div style={{ ...ui.row, justifyContent: 'space-between' }}>
          <h2 style={ui.h2}>Kunder</h2>
          <button type="button" style={ui.btnSecondary} onClick={() => setEditing({ kind: 'customer', item: null })}>Ny kunde</button>
        </div>
        {editing?.kind === 'customer' && !editing.item && (
          <div style={{ padding: '8px 0 16px' }}><CustomerForm orgId={orgId} onSaved={done} onCancel={done} /></div>
        )}
        {customersLoading && <p style={ui.hint}>Laster…</p>}
        {!customersLoading && customers.length === 0 && <p style={ui.hint}>Ingen kunder ennå.</p>}
        {customers.map(c => (
          <div key={c.id}>
            <div style={ui.listRow}>
              <span>
                <strong>{c.name}</strong>
                <span style={{ display: 'block', ...ui.hint }}>{[c.contactName, c.phone, c.address?.city].filter(Boolean).join(' · ')}</span>
              </span>
              <span style={ui.row}>
                <button type="button" style={ui.btnSecondary} onClick={() => setEditing({ kind: 'customer', item: c })}>Rediger</button>
                <button type="button" style={ui.btnDanger} onClick={() => remove('customer', c)}>Slett</button>
              </span>
            </div>
            {editing?.kind === 'customer' && editing.item?.id === c.id && (
              <div style={{ padding: '8px 0 16px' }}><CustomerForm orgId={orgId} customer={c} onSaved={done} onCancel={done} /></div>
            )}
          </div>
        ))}
      </div>

      <div style={ui.card}>
        <div style={{ ...ui.row, justifyContent: 'space-between' }}>
          <h2 style={ui.h2}>Faste hentesteder</h2>
          <button type="button" style={ui.btnSecondary} onClick={() => setEditing({ kind: 'pickup', item: null })}>Nytt hentested</button>
        </div>
        <p style={ui.hint}>Vises som valg når du legger inn en ordre.</p>
        {editing?.kind === 'pickup' && !editing.item && (
          <div style={{ padding: '8px 0 16px' }}><PickupForm orgId={orgId} onSaved={done} onCancel={done} /></div>
        )}
        {pickupsLoading && <p style={ui.hint}>Laster…</p>}
        {!pickupsLoading && pickups.length === 0 && <p style={ui.hint}>Ingen faste hentesteder ennå.</p>}
        {pickups.map(p => (
          <div key={p.id}>
            <div style={ui.listRow}>
              <span>
                <strong>{p.name}</strong>
                <span style={{ display: 'block', ...ui.hint }}>{p.address?.street}</span>
              </span>
              <span style={ui.row}>
                <button type="button" style={ui.btnSecondary} onClick={() => setEditing({ kind: 'pickup', item: p })}>Rediger</button>
                <button type="button" style={ui.btnDanger} onClick={() => remove('pickup', p)}>Slett</button>
              </span>
            </div>
            {editing?.kind === 'pickup' && editing.item?.id === p.id && (
              <div style={{ padding: '8px 0 16px' }}><PickupForm orgId={orgId} pickup={p} onSaved={done} onCancel={done} /></div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
